var exports = {
  "if": "MetadataRuleMainContainer___6RHJJ",
  "hy": "MetadataRuleInnerContainer__XV3t2e",
  "lj": "MetadataRuleLabelContainer__raxJPB",
  "vW": "MetadataRuleDescriptionContainer__1l7h17",
  "lF": "MetadataRulePatternBadge__san8Z4",
  "Ft": "MetadataRulePatternText__4VXy1C",
  "eE": "MetadataRuleActionsContainer__YsxUF4",
  "bX": "MetadataRuleDeleteButton__uRi4sF",
};

module.exports = exports;
